import { Grid } from '@mui/material';
import styled from 'styled-components';

export type EmptyTableContentPropsType = {
  message?: string | number;
  iconColor?: string;
  messageColor?: string;
  IconEl?: JSX.Element | any;
};

type WrapperProps = {
  iconColor?: string;
  messageColor?: string;
};

const Wrapper = styled.div<WrapperProps>`
  margin-top: 40px;
  color: green;
  .message {
    font-size: 0.8125rem;
    color: ${(props) => props.messageColor || 'grey'};
  }

  .icon {
    color: ${(props) => props.iconColor || 'green'};
    font-size: 3em;
  }
`;

const EmptyTableContent: React.FC<EmptyTableContentPropsType> = ({
  message,
  messageColor,
  iconColor,
  IconEl,
}) => {
  return (
    <Wrapper className="empty-content-wrapper" messageColor={messageColor} iconColor={iconColor}>
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Grid className="message">{message}</Grid>
        <Grid size="auto"> {IconEl && <IconEl className="icon" />}</Grid>
      </Grid>
    </Wrapper>
  );
};

export default EmptyTableContent;
